var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.6256L7.32667 11.9763C6.63165 12.6317 5.68899 13 4.70608 13C3.72317 13 2.78051 12.6317 2.08549 11.9763C1.39046 11.3208 1 10.4317 1 9.5047C1 8.57769 1.39046 7.68865 2.08549 7.03315L7.75881 1.6825C8.22216 1.2455 8.8506 1 9.50587 1C10.1611 1 10.7896 1.2455 11.2529 1.6825C11.7163 2.1195 11.9766 2.71219 11.9766 3.3302C11.9766 3.94821 11.7163 4.5409 11.2529 4.9779L5.57344 10.3286C5.34176 10.5471 5.02754 10.6698 4.69991 10.6698C4.37227 10.6698 4.05805 10.5471 3.82638 10.3286C3.5947 10.1101 3.46455 9.81371 3.46455 9.5047C3.46455 9.1957 3.5947 8.89935 3.82638 8.68085L9.06756 3.74358",
    stroke: "#A793F6",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.fb42053d7b1ca086401427b26b60430d.svg";
export { ForwardRef as ReactComponent };